export default class TransferSearch {
    memberId: string;
    subscriberMemberId: string;
    socialSecurityNumber: string;

  constructor() {}
}